import React, { useMemo, useState } from 'react';
import dashboardStyle from "../styles/Dashboard.module.css";
import styles from "../styles/MeasureLittle.module.css";
import Danger from "../images/Danger.png";
import videoBuzo from "../videos/videoBuzos.mp4";
import videoRemeras from "../videos/video2.mp4";
import GuiaTalleDinamicaModal from './GuiaTalleDinamicaModal ';

// El id va junto al nombre: el nombre es lo que se muestra y con lo que viene indexada la
// respuesta, pero el id es lo que hace falta para pedir el CATÁLOGO de talles cuando el pedido
// todavía no tiene los suyos cargados.
const MOLDERIAS = [
  {
    id: 1,
    name: 'Jardín',
    hint: 'Para peques y primeras edades, con referencia corta y rápida.',
  },
  {
    id: 2,
    name: 'Primaria/Secundaria',
    hint: 'La guía más usada para encontrar talle en prendas escolares.',
  },
  {
    id: 3,
    name: 'Oversize',
    hint: 'Ideal si buscás una caída más amplia y relajada.',
  },
];

const MediTuLittleModal = ({ prendaSeleccionada, onClose, order_id }) => {
  const [molderiaActiva, setMolderiaActiva] = useState(null);

  const abrirGuia = (molderia) => setMolderiaActiva(molderia);
  const cerrarGuia = () => setMolderiaActiva(null);

  const category = prendaSeleccionada?.category_name;
  const productName = prendaSeleccionada?.product_name || "tu prenda";

  const videoData = useMemo(() => {
    if (["Buzos", "Camperas"].includes(category)) {
      return {
        src: videoBuzo,
        label: "Video guía para buzos y camperas",
        hint: "Apoyá una prenda que te quede bien sobre una superficie plana y seguí el video paso a paso.",
      };
    }

    if (["Remeras", "Chombas"].includes(category)) {
      return {
        src: videoRemeras,
        label: "Video guía para remeras y chombas",
        hint: "Compará ancho y alto con una prenda cómoda para elegir el talle sin dudas.",
      };
    }

    return null;
  }, [category]);

  return (
    <div className={dashboardStyle.modalBackground}>
      <div className={styles.measureModal}>
        <button className={dashboardStyle.closer} onClick={onClose} aria-label="Cerrar Medí tu Little">
          <i className="bi bi-x-lg" />
        </button>

        <div className={styles.measureContent}>
          <div className={styles.measureHeader}>
            <span className={styles.measureStep}>
              <i className="bi bi-rulers" /> Medidas y guía
            </span>
            <h2 className={styles.measureTitle}>
              Medí tu <span className={styles.measureTitleAccent}>Little</span>
            </h2>
            <p className={styles.measureSubtitle}>
              Te mostramos cómo medir {productName} para que el talle quede mucho más claro antes de cargarlo.
            </p>
          </div>

          <div className={styles.measureIntroCard}>
            <div className={styles.measureIntroIcon}>
              <img src={Danger} alt="Atención" />
            </div>
            <div className={styles.measureIntroBody}>
              <span className={styles.measureIntroEyebrow}>Antes de elegir</span>
              <p className={styles.measureIntroTitle}>Usá una prenda que ya te quede cómoda</p>
              <p className={styles.measureIntroText}>
                Medila estirada sobre una superficie plana. Si te da entre dos talles, siempre conviene ir por el más grande.
              </p>
            </div>
          </div>

          <div className={styles.measureBody}>
            <div className={styles.measureVideoCard}>
              <div className={styles.measureCardHeader}>
                <span className={styles.measureCardEyebrow}>Tutorial</span>
                <p className={styles.measureCardTitle}>Mirá cómo tomar las medidas</p>
              </div>

              {videoData ? (
                <>
                  <video className={styles.measureVideo} controls>
                    <source src={videoData.src} type="video/mp4" />
                    Tu navegador no admite el elemento <code>video</code>.
                  </video>
                  <p className={styles.measureVideoHint}>{videoData.hint}</p>
                </>
              ) : (
                <p className={styles.measureVideoHint}>
                  Para esta categoría todavía no hay video puntual, pero podés usar las guías de talles de abajo para orientarte.
                </p>
              )}
            </div>

            <div className={styles.measureMolderiasCard}>
              <div className={styles.measureCardHeader}>
                <span className={styles.measureCardEyebrow}>Guías disponibles</span>
                <p className={styles.measureCardTitle}>Elegí la moldería que querés revisar</p>
              </div>

              <div className={styles.measureMolderiasList}>
                {MOLDERIAS.map((molderia) => (
                  <div className={styles.measureMolderiaRow} key={molderia.name}>
                    <div className={styles.measureMolderiaCopy}>
                      <span className={styles.measureMolderiaLabel}>{molderia.name}</span>
                      <span className={styles.measureMolderiaHint}>{molderia.hint}</span>
                    </div>
                    <button
                      type="button"
                      className={styles.measureMolderiaBtn}
                      onClick={() => abrirGuia(molderia)}
                    >
                      Ver guía de talles <i className="bi bi-chevron-right" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles.measureFooter}>
            <button type="button" className={styles.measureSecondaryBtn} onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>

        {molderiaActiva && (
          <GuiaTalleDinamicaModal
            order_id={order_id}
            molderia={molderiaActiva.name}
            moldingId={molderiaActiva.id}
            onClose={cerrarGuia}
          />
        )}
      </div>
    </div>
  );
};

export default MediTuLittleModal;
